import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./LendingReferenceSection.css";
import loanApplicationUtility from "../../../utilities/LoanApplicationUtility";

interface LendingReferenceSectionProps {
  loanDetails: LoanApplication
}

export default class LendingReferenceSection extends React.Component<LendingReferenceSectionProps> {
  render() {
    return (
      <>
        {this.props.loanDetails.loanLendingReference !== undefined &&
          (<>
            <div>
              <h3>Main Lending Reference</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <>
                    <tr>
                      <td width="250px" className="app-info"><strong>Reference Information</strong></td>
                      <td className="app-info">{`${this.props.loanDetails.loanLendingReference?.bankName ?? 'N/A'}, ${this.props.loanDetails.loanLendingReference?.contactName ?? 'N/A'}, ${loanApplicationUtility.FormatPhoneNumber(this.props.loanDetails.loanLendingReference?.phoneNumber ?? '')}`}</td>
                    </tr>
                  </>
                </tbody>
              </Table>
            </div>
          </>)
        }
      </>
    );
  }
}